import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './api/request.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'lib-flexible'; //自适应样式
import LyTab from 'ly-tab' //头部滚动插件
import $ from 'jquery'


Vue.use(LyTab) // 之后便可在全局使用了

Vue.use(ElementUI)
    //全局注册axios
Vue.prototype.$axios = axios;
Vue.prototype.$ = $;

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js